<template lang="html">
  <pl-dialog
    :disableOutsideClick="true"
    :title="`You have to connect your
          ${selectedIntegration.name} Account.`"
    :size="'md'"
    @close="$emit('close')"
  >
    <div class="center mv4">
      <p class="tc px-7 txt-modal-upgrade">
        You must connect your {{ selectedIntegration.name }} account to your
        Parlay account before you can use the LMS integration. You must go to
        your Profile Integrations page to set up the connection.
      </p>
    </div>
    <div class="integrations-container w-70">
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <img :src="icon" height="50px" width="50px" />
          <span class="integration-classroom-title ml3">
            {{ selectedIntegration.name }}
          </span>
        </div>
        <button
          class="px-4 py-2 bg-primary text-white rounded font-semibold truncate-text"
          @click="goToProfileIntegrations"
        >
          Set Up Connection
        </button>
      </div>
    </div>
  </pl-dialog>
</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {};
    },
    props: {
      selectedIntegration: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['getCourseDetail']),
      selected_integration() {
        if (this.selectedIntegration === 'google-classroom') {
          return 'Google Classroom';
        }
        return (
          this.selectedIntegration.charAt(0).toUpperCase() +
          this.selectedIntegration.slice(1)
        );
      },
      integration() {
        return this.getCourseDetail.edlink_integrations.find(
          (x) => x.provider_name.toLowerCase() === this.selectedIntegration
        );
      },
      icon() {
        const title = this.selectedIntegration.name;
        return `/static/integrations/${title}.png`;
      },
    },
    methods: {
      goToProfileIntegrations() {
        const route = {
          name: 'profile.integrations',
        };
        this.$router.push(route);
        this.$emit('close');
      },
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl';

  .integrations-container
    margin-left: auto
    margin-right: auto
    margin-bottom: 20px
    padding: 1rem
    border-right: 1px solid rgba(0,0,0,.2)
    border-bottom: 1px solid rgba(0,0,0,.2)
  .integration-classroom-title
    font-size: 18px
    line-height: 22px
    color: #273248
    font-weight: 600
  .google_classroom_connected
    margin: 16px 0 0 0
  .name-of-class
    display: block
    font-size: 24px
    line-height: 29px
    color: #273248
    font-weight: 600
</style>



// WEBPACK FOOTER //
// integrationsConnectAccountModal.vue?263deb17